import React from "react";
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from "../../components/modules/pannelli/ThemesScreen";
import { VitHeadLinks } from "../../components/modules/pannelli/HeadLink";
import "../../components/modules/pannelli/themesScreen.scss";

function TecnicaColtiva() {
    const {theme} = useSingleTheme('vitigno');
    const vitigno_Theme = theme;
    const {articles} = useArticles('vitigno');
    const article = articles.slice(2, 3) || [];
    const articles_Tecnica = article[0]; 
    const {paragraphs} = useParagraphs('vitigno_3');

    return (
        <section>
            {theme && <VitHeadLinks title={vitigno_Theme.tema_titolo} /> }
            <ThemesScreen theme={vitigno_Theme} article={articles_Tecnica} paragraphs={paragraphs}/> 
        </section>
    )
}
export default TecnicaColtiva;
